import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';

export default function Footer() {
    return (
        <footer id="contact" className="bg-gray-900 text-gray-300 py-16 px-6">
            <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-12">
                <div className="col-span-1 lg:col-span-2">
                    <h3 className="text-white text-2xl font-bold mb-6 flex items-center gap-2">
                        <span className="bg-red-600 text-white p-1 rounded text-lg">C4S</span>
                        Cars4Sell Import
                    </h3>
                    <p className="mb-6 max-w-md leading-relaxed">
                        Jesteśmy Twoim partnerem w świecie motoryzacji. Sprowadzamy auta z pasją i dbałością o każdy detal.
                        Zaufaj profesjonalistom.
                    </p>
                    <div>
                        <h4 className="text-lg font-bold mb-4">Lokalizacja</h4>
                        <div className="flex items-start gap-3 text-gray-300 mb-4">
                            <MapPin size={20} className="mt-1 flex-shrink-0" />
                            <p>
                                ul. Świerkowa 2<br />
                                16-423 Bakałarzewo<br />
                                Polska
                            </p>
                        </div>
                        <div className="rounded-lg overflow-hidden h-48 bg-gray-800">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2346.669865186454!2d22.6455!3d54.0855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46e1010000000001%3A0x0!2s%C5%9Awierkowa%202%2C%2016-423%20Baka%C5%82arzewo!5e0!3m2!1spl!2spl!4v1600000000000!5m2!1spl!2spl"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title="Mapa dojazdu"
                            ></iframe>
                        </div>
                    </div>
                </div>

                <div>
                    <h4 className="text-white font-bold text-lg mb-6">Kontakt</h4>
                    <ul className="space-y-4">
                        <li className="flex items-center gap-3">
                            <Phone className="h-5 w-5 text-red-500" />
                            <a href="tel:+48538194234" className="hover:text-white transition-colors">+48 538 194 234</a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail className="h-5 w-5 text-red-500" />
                            <a href="mailto:kontakt@cars4sell.pl" className="hover:text-white transition-colors">kontakt@cars4sell.pl</a>
                        </li>
                        <li className="flex items-center gap-3">
                            <MapPin className="h-5 w-5 text-red-500" />
                            <span>Bakałarzewo, Polska</span>
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-white font-bold text-lg mb-6">Godziny otwarcia</h4>
                    <ul className="space-y-2">
                        <li className="flex justify-between">
                            <span>Pon - Pt:</span>
                            <span className="text-white">9:00 - 19:00</span>
                        </li>
                        <li className="flex justify-between">
                            <span>Sobota:</span>
                            <span className="text-white">9:00 - 16:00</span>
                        </li>
                        <li className="flex justify-between">
                            <span>Niedziela:</span>
                            <span className="text-red-500">Nieczynne</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-gray-800 text-center text-sm text-gray-400 flex flex-col md:flex-row justify-between items-center gap-4">
                <p>&copy; {new Date().getFullYear()} Cars4Sell Import. Wszelkie prawa zastrzeżone. Właścicielem serwisu jest 4SELL Grzegorz Szostak.</p>
                <Link to="/polityka-prywatnosci" className="hover:text-white transition-colors">Polityka Prywatności</Link>
            </div>
        </footer>
    );
}
